import { useNavigation } from 'react-router';

import { useIsClient } from '#/hooks/useIsClient';

export function TrackNavigationStateGlobalHandler() {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';
  const isClient = useIsClient();

  if (!isLoading && isClient) return null;

  return <div id="loadingRoute" data-hydrated={isClient ? true : undefined} />;
}
